import React, { useEffect, useState } from 'react';
import ResponseBarChart from './ResponseBarChart';
import { PositiveMoodChart, NegativeMoodChart } from './ResponseLineCharts'; 
import { downloadResponsesCSV } from '../utils/csvHelper';
import api from '../utils/axiosConfig';
import API_BASE from '..//config';
import '../css/AdminParticipantPage.css';

function AdminParticipantPage() {
  const [participants, setParticipants] = useState([]);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [responses, setResponses] = useState([]);
  const [sessionInfo, setSessionInfo] = useState(null);
  const [error, setError] = useState('');

  // Items to be ignored
  const excludedItemNames = ['Start', 'decl_01', 'decl_auditiv', 'decl_vis', 'feedback', 'End'];

  useEffect(() => {
    const fetchParticipants = async () => {
      try {
        const res = await api.get('/api/participants');
        setParticipants(res.data);
      } catch (err) {
        console.error(err);
        setError('Fehler beim Laden der Teilnehmer.');
      }
    };

    fetchParticipants();
  }, []);

  const handleChange = async (e) => {
    const participantId = e.target.value;
    const participant = participants.find(p => p._id === participantId);
    setSelectedParticipant(participant);

    try {
      const res = await api.get(`${API_BASE}/api/responses/${participant.code}`);
      setResponses(res.data);

      if (res.data.length > 0) {
        const [ , date, time] = res.data[0].session_id.split('_');
        const hour = time?.split('-')[0];
        setSessionInfo({ date, hour });
      }
    } catch (err) {
      console.error(err);
      setError('Fehler beim Laden der Antworten.');
    }
  };

  return (
    <div className="participant-info-page">
      <h1>Teilnehmerdaten</h1>

      <label>Teilnehmer auswählen:</label>
      <select onChange={handleChange} defaultValue="">
        <option value="" disabled>-- Teilnehmer wählen --</option>
        {participants.map(p => (
          <option key={p._id} value={p._id}>
            {p.name} ({p.code})
          </option>
        ))}
      </select>

      {selectedParticipant && (
        <div className="responses-container">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h3>Antworten für {selectedParticipant.name}</h3>
            {sessionInfo && (
              <div>
                <strong>Startdatum:</strong> {sessionInfo.date}<br />
                {/* <strong>Zeitfenster:</strong> {sessionInfo.hour} bis {parseInt(sessionInfo.hour) + 1} Uhr */}
              </div>
            )}
          </div>


          {/* Add the chart above the table */}
              {responses.length > 0 && (
                <div style={{ marginBottom: '2rem' }}>
                  <ResponseBarChart responses={responses} />
                  <PositiveMoodChart responses={responses} />
                  <NegativeMoodChart responses={responses} />
                </div>
              )}

        {responses.length === 0 ? (
          <p>Keine Antworten gefunden.</p>
        ) : (
          <div>
            <button 
              onClick={() => downloadResponsesCSV(responses, excludedItemNames, selectedParticipant.code)}
              className="download-button"
            >
              Rohdaten als CSV herunterladen
            </button>
          </div>
        )}

          {/* Optionally keep your table here if needed */}
        </div>
      )}

      {error && <p>{error}</p>}
    </div>
  );
}

export default AdminParticipantPage;
